import React from 'react';

const Confirm: React.FC = () => {
  return <div>Co-Contributions Confirm Step</div>;
};

export default Confirm;
